import React from 'react';
import * as S from './Button.styled';
import { UnreadDot } from '../Dashboard.styled';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

// specify in a button prop called color, border and/or background a string of purple, green, blue or red to get the desired style

type ButtonProps = Omit<
    React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
    'onClick'
> & {
    children: React.ReactNode;
    border?: string;
    color?: string;
    background?: string;
    onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
    style?: React.CSSProperties;
    isActive?: boolean;
    disabled?: boolean;
    isUnreadNotifications?: boolean;
    isUnreadMessages?: boolean;
};

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
    (
        {
            children,
            color,
            border,
            background,
            onClick,
            style = {},
            isActive,
            disabled,
            isUnreadNotifications,
            isUnreadMessages,
            ...rest
        },
        ref
    ) => {
        const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
        const { t } = useTranslation();

        return (
            <S.Button
                ref={ref}
                style={{
                    ...style,
                }}
                $isActive={isActive}
                border={border}
                color={color}
                background={background}
                onClick={onClick}
                disabled={disabled}
                isUnreadNotifications={isUnreadNotifications}
                isUnreadMessages={isUnreadMessages}
                {...rest}
            >
                {children}

                {Array.isArray(children) &&
                    children.includes(t('notifications', { lng: language })) &&
                    isUnreadNotifications && (
                        <UnreadDot style={{ marginLeft: '0.1rem', marginTop: '0.5rem' }} />
                    )}
                {Array.isArray(children) &&
                    children.includes(t('chats', { lng: language })) &&
                    isUnreadMessages && (
                        <UnreadDot style={{ marginLeft: '0.1rem', marginTop: '0.5rem' }} />
                    )}
            </S.Button>
        );
    }
);

Button.displayName = 'Button';

export default Button;
